<app-chat-input-form
  class="chat-input"
  [ngClass]="{'chat-input-mobile': isMobile}"
  [onSaveNote]="saveNote"
  [disabled]="disabled"
  [showForBar]="false"
  [showExternalNotes]="false"
  [showInternalExternalSelect]="false"
  [label]="'SERVICE.CHAT_PLACEHOLDER' | translate"
  [maxlength]="950"
  [maxlengthMsg]="1000"
  [heightCarousel]="heightCarousel"
  (onFilesUploaded)="filesUploaded($event)"
  [chatType]="chatType"
></app-chat-input-form>
<div class="disableCoverBox" *ngIf="disabled">
  <div class="disableCover"  [ngClass]="{'disableCover_mobile' : isMobile}" >
    <div class="closedChatMessageLine"  [ngClass]="{'closedChatMessageLine_mobile': isMobile}" (click)="openNewTicket()">
      <span class="pinkText">{{'SERVICE.CLOSE_CHAT_TEXT_1' | translate}}</span>
      <span> {{'SERVICE.CLOSE_CHAT_TEXT_2' | translate}} </span>
      <span class="as-link" >{{'SERVICE.CLOSE_CHAT_BUTTON_TEXT' | translate}}</span>
    </div>
  </div>
  
</div>
